import { Encriptar } from "./Util/Encripcion";
import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import avatar from "./avatarnuevo.png";
import Moment from "moment";
import axios, { AxiosRequestConfig } from "./axios-config";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { FaPhoneSquareAlt } from "react-icons/fa";
import zxcvbn from "zxcvbn";
import AppCentral from "./AppCentral.js";
import Select from "react-select";
import logo2 from "./logo2.jpg";
import pag from "./pagos.png";
import all from "./all.png";
import cardPoliza from "./assets/card-poliza2.png";
import cardAsesor from "./assets/card-asesor.png";
import cardGestiones from "./assets/card-gestiones.png";
import cardCarnet from "./assets/card-digital.png";
import cardProveedores from "./assets/card-proveedores.png";
import a1 from "./aseguradoras/1.png";
import a2 from "./aseguradoras/2.png";
import a3 from "./aseguradoras/3.jpeg";
import a6 from "./aseguradoras/6.png";
import a7 from "./aseguradoras/7.png";
import a8 from "./aseguradoras/8.png";
import a10 from "./aseguradoras/10.jpg";
import a11 from "./aseguradoras/11.png";
import a12 from "./aseguradoras/12.jpg";
import a13 from "./aseguradoras/13.png";
import a15 from "./aseguradoras/15.png";
import a28 from "./aseguradoras/28.png";
import a630 from "./aseguradoras/630.png";
import Poliza from "./poliza.js";
import RedProveedores from "./RedProveedores/RedProveedores.js";
import PolizaDanos from "./polizadanos.js";
import Asesor from "./asesor.js";
import gestiones from "./gestiones.js";
import fs from "fs";
import XlsxPopulate from "xlsx-populate";
import gestion_reclamo from "./gestion_reclamo.js";
import bitacora_reclamo from "./bitacora_Reclamo.js";
import TablaCuenta from "./TablaCuenta.js";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";
import ReactDOMServer from "react-dom/server";
import {
  Card,
  CardBody,
  CardImg,
  CardTitle,
  CardText,
  CardHeader,
  CardFooter,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Button,
} from "reactstrap";

import { Ambulance } from "lucide-react";
import { Modal } from "react-bootstrap";
import swal from "sweetalert";

import {
  EReCaptchaV2Size,
  EReCaptchaV2Theme,
  ReCaptchaProvider,
  ReCaptchaV2,
} from "react-recaptcha-x";
import $ from "jquery";
import { DesEncriptar } from "./Util/Encripcion";
import CarnetDigital from "./CarnetDigital/CarnetDigital.js";
import NumeroCabina from "./Asistencias/NumeroCabina.js";
import AseguradoraContext from "./context/AseguradoraContext.js";

class Forms extends Component {
  static contextType = AseguradoraContext;

  constructor(props) {
    super(props);

    this.state = {
      state: "",
      imag: all,
      info_cliente: [],
      informacion: [],
      idCliente: window.idCliente,
      pnamACT: window.pnombre,
      snamACT: window.psegundonombre,
      papeACT: window.pprimerapellido,
      sapeACT: window.psegundoapellido,
      emACT: window.pemail,
      direACT: window.pdireccion,
      telACT: window.ptelefono,
      telACT2: window.ptelefono,
      regexp: 999999,
      selectedOptionRam: null,
      selectedOptionit: null,
      contra: "",
      monedaPol: "",
      tipPoliza: "",
      validacion: "",
      show: false,
      name: "React",
      showHideDemo1: false,
      showHideDemo2: false,
      showHideDemo3: false,
      handleShow1: false,
      showResults: false,
      modal: false,
      large: false,
      small: false,
      primary: false,
      success: false,
      warning: false,
      danger: false,
      info: false,
      type: "password",
      typeModal: "password",
      typeModal3: "password",
      collapse: true,
      valDanos: 0,
      datospoliza: [],
      datosramos: [],
      datosramosTodos: [],
      datosit: [],
      score: "null",
      fadeIn: true,
      cliente: "",
      poli: "",
      tipPo: "",
      idRam: "",
      tipRam: "",
      titulo: "",
      ventana: "",
      timeout: 300,
      numeroTelefonoAsis: "",
      numeroTelefonoCabina: "",
      telefonoCab: ""
    };
    this.toggle1 = this.toggle1.bind(this);
    this.toggleFade1 = this.toggleFade1.bind(this);
    this._reCaptchaRef = React.createRef();
    this.handleChangeRam = this.handleChangeRam.bind(this);
    this.getSheetData = this.getSheetData.bind(this);
    this.handleGenerate2 = this.handleGenerate2.bind(this);
    this.handleGenerate = this.handleGenerate.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.handleChangeTi = this.handleChangeTi.bind(this);
  }

  getSheetData(data, header) {
    var fields = Object.keys(data[0]);
    var sheetData = data.map(function (row) {
      return fields.map(function (fieldName) {
        return row[fieldName] ? row[fieldName] : "";
      });
    });
    sheetData.unshift(header);
    return sheetData;
  }

  handleClickNumCabina(tipo) {
    // e.preventDefault();

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      if (tipo == 1) { // cabina de asistencia
        window.location.href = `tel:${this.state.numeroTelefonoAsis}`;
      }
      if (tipo == 2) { // cabina de emergencia
        window.location.href = `tel:${this.state.numeroTelefonoCabina}`;
      }

    } else {
      // Mostrar swal en web
      Swal.fire({
        title: ReactDOMServer.renderToString(
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <span
              style={{
                marginTop: "10px",
                fontSize: "25px",
                fontWeight: "bold",
                color: "#872434",
              }}
            >
              {tipo === 1 ? "Cabina de Asistencias" : "Cabina de Emergencia"}
            </span>
          </div>
        ),
        html: ReactDOMServer.renderToString(
          <p>
            Llame al número:{" "}
            <b>
              <FaPhoneSquareAlt size={25} color="#003479" />
              {this.state.numeroTelefonoAsis}
            </b>
          </p>
        ),
        showConfirmButton: true,
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#003479",
      });
    }
  };

  async handleGenerate() {
    let header2 = [
      "Asegurado",
      "Aseguradora",
      "Codigo Cliente",
      "Número Póliza",
      "Tipo Póliza",
      "Vigencia Fin",
      "Vigencia Inicio",
    ];
    let datos = [];
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/listadoPolizas/` +
        $("#idclienteF").val(),
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
          },
        }
      )
      .then((json) => {
        if (json.status === 200) {
          if (json.data.informacion.informacionPolizas.length <= "1") {
            datos.push(json.data.informacion.informacionPolizas);
            XlsxPopulate.fromBlankAsync().then(async (workbook) => {
              const sheet1 = workbook.sheet(0);
              const sheetData = this.getSheetData(datos, header2);
              const totalColumns = sheetData[0].length;

              sheet1.cell("A1").value(sheetData);
              const range = sheet1.usedRange();
              const endColumn = String.fromCharCode(64 + totalColumns);
              sheet1.row(1).style("bold", true);
              sheet1.range("A1:" + endColumn + "1").style("fill", "BFBFBF");
              range.style("border", true);
              return workbook.outputAsync().then((res) => {
                saveAs(
                  res,
                  "ListadoPolizas_" + $("#idclienteF").val() + ".xlsx"
                );
              });
            });
          } else {
            XlsxPopulate.fromBlankAsync().then(async (workbook) => {
              const sheet1 = workbook.sheet(0);
              const sheetData = this.getSheetData(
                json.data.informacion.informacionPolizas,
                header2
              );
              const totalColumns = sheetData[0].length;

              sheet1.cell("A1").value(sheetData);
              const range = sheet1.usedRange();
              const endColumn = String.fromCharCode(64 + totalColumns);
              sheet1.row(1).style("bold", true);
              sheet1.range("A1:" + endColumn + "1").style("fill", "BFBFBF");
              range.style("border", true);
              return workbook.outputAsync().then((res) => {
                saveAs(
                  res,
                  "ListadoPolizas_" + $("#idclienteF").val() + ".xlsx"
                );
              });
            });
          }
        } else {
          swal("Error", "datos,", "warning");
        }
      })
      .catch(function (error) { });
  }

  async handleGenerate2() {
    const aMoneda = (numero, opciones) => {
      // Valores por defecto
      opciones = opciones || {};
      opciones.simbolo = opciones.simbolo || "$";
      opciones.separadorDecimal = opciones.separadorDecimal || ".";
      opciones.separadorMiles = opciones.separadorMiles || ",";
      opciones.numeroDeDecimales =
        opciones.numeroDeDecimales >= 0 ? opciones.numeroDeDecimales : 2;
      opciones.posicionSimbolo = opciones.posicionSimbolo || "i";
      const CIFRAS_MILES = 3;

      // Redondear y convertir a cadena
      var num = parseFloat(numero);

      let numeroComoCadena = num.toFixed(opciones.numeroDeDecimales);

      // Comenzar desde la izquierda del separador o desde el final de la cadena si no se proporciona
      let posicionDelSeparador = numeroComoCadena.indexOf(
        opciones.separadorDecimal
      );
      if (posicionDelSeparador === -1)
        posicionDelSeparador = numeroComoCadena.length;
      let formateadoSinDecimales = "",
        indice = posicionDelSeparador;
      // Ir cortando desde la derecha de 3 en 3, y concatenar en una nueva cadena
      while (indice >= 0) {
        let limiteInferior = indice - CIFRAS_MILES;
        // Agregar separador si cortamos más de 3
        formateadoSinDecimales =
          (limiteInferior > 0 ? opciones.separadorMiles : "") +
          numeroComoCadena.substring(limiteInferior, indice) +
          formateadoSinDecimales;
        indice -= CIFRAS_MILES;
      }
      let formateadoSinSimbolo = `${formateadoSinDecimales}${numeroComoCadena.substr(
        posicionDelSeparador,
        opciones.numeroDeDecimales + 1
      )}`;
      return opciones.posicionSimbolo === "i"
        ? opciones.simbolo + formateadoSinSimbolo
        : formateadoSinSimbolo + opciones.simbolo;
    };
    // Probar
    const opcionesQuetzales = {
      numeroDeDecimales: 2,
      separadorDecimal: ".",
      separadorMiles: ",",
      simbolo: "Q ", // Con un espacio, ya que la función no agrega espacios
      posicionSimbolo: "i", // i = izquierda, d = derecha
    },
      opcionesDolares = {
        numeroDeDecimales: 2,
        separadorDecimal: ".",
        separadorMiles: ",",
        simbolo: " USD", // Con un espacio, ya que la función no agrega espacios
        posicionSimbolo: "d", // i = izquierda, d = derecha
      };

    let header2 = [
      "Ramo",
      "Poliza",
      "Nombre",
      "Pago",
      "Factura",
      "Prima",
      "Vencimiento",
    ];
    let datos = [];
    var clienteReporte = $("#idclienteF").val();
    var esAsazgua = false;
    var tieneDatos = false;
    var urlGet = $("#idclienteF").val();
    if ($("#hdEsAzasgua").val() == "S") {
      clienteReporte = $("#hdClienteActual").val();
      esAsazgua = true;
      urlGet = $("#idepol").val() + "/" + $("#hdClienteActual").val();
    }
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/estadoPendiente/` +
        urlGet,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
          },
        }
      )
      .then((json) => {
        var facturas = 0;
        if (json.status === 200) {
          if (json.data.informacion.facturasClientesWeb.length <= "1") {
            if (
              !esAsazgua ||
              (esAsazgua &&
                json.data.informacion.facturasClientesWeb.numeroPoliza ==
                $("#hdNumPolAzasgua").val() &&
                json.data.informacion.facturasClientesWeb.codigoCliente ==
                $("#hdClienteActual").val())
            ) {
              if (json.data.informacion.facturasClientesWeb.estado == "V") {
                datos.push(json.data.informacion.facturasClientesWeb);
                facturas++;
              }
              if (facturas > 0) {
                XlsxPopulate.fromBlankAsync().then(async (workbook) => {
                  const sheet1 = workbook.sheet(0);
                  const sheetData = this.getSheetData(datos, header2);
                  const totalColumns = sheetData[0].length;
                  sheet1.cell("A1").value(sheetData);
                  const range = sheet1.usedRange();
                  const endColumn = String.fromCharCode(64 + totalColumns);
                  sheet1.row(1).style("bold", true);
                  sheet1.range("A1:" + endColumn + "1").style("fill", "BFBFBF");
                  range.style("border", true);
                  return workbook.outputAsync().then((res) => {
                    saveAs(
                      res,
                      "FacturasPendientes_" + clienteReporte + ".xlsx"
                    );
                  });
                });
              }
            } else {
              swal("Error", "No se encontraron datos", "warning");
            }
          } else {
            XlsxPopulate.fromBlankAsync().then(async (workbook) => {
              for (
                var i = 0;
                i < json.data.informacion.facturasClientesWeb.length;
                i++
              ) {
                if (
                  json.data.informacion.facturasClientesWeb[i].estado == "V"
                ) {
                  if (
                    !esAsazgua ||
                    (esAsazgua &&
                      json.data.informacion.facturasClientesWeb[i]
                        .numeroPoliza == $("#hdNumPolAzasgua").val() &&
                      json.data.informacion.facturasClientesWeb[i]
                        .codigoCliente == $("#hdClienteActual").val())
                  ) {
                    if (
                      json.data.informacion.facturasClientesWeb.codigoMoneda ==
                      1 ||
                      json.data.informacion.facturasClientesWeb.codigoMoneda ==
                      "1"
                    ) {
                      datos.push({
                        TIPOPOLIZA:
                          json.data.informacion.facturasClientesWeb[i]
                            .tipoPoliza,
                        NUMEROPOLIZA:
                          json.data.informacion.facturasClientesWeb[i]
                            .numeroPoliza,
                        NOMBRE:
                          json.data.informacion.facturasClientesWeb[i].nombre,
                        NUMEROPAGO:
                          json.data.informacion.facturasClientesWeb[i]
                            .numeroPago,
                        FACTURA:
                          json.data.informacion.facturasClientesWeb[i]
                            .numeroFactura,
                        PRIMA: aMoneda(
                          json.data.informacion.facturasClientesWeb[i].prima,
                          opcionesQuetzales
                        ),
                        VENCIMIENTO: Moment(
                          json.data.informacion.facturasClientesWeb[i]
                            .fechaDeVencimiento
                        ).format("L"),
                      });
                      datos.push({
                        TIPOPOLIZA:
                          json.data.informacion.facturasClientesWeb[i]
                            .tipoPoliza,
                        NUMEROPOLIZA:
                          json.data.informacion.facturasClientesWeb[i]
                            .numeroPoliza,
                        NOMBRE:
                          json.data.informacion.facturasClientesWeb[i].nombre,
                        NUMEROPAGO:
                          json.data.informacion.facturasClientesWeb[i]
                            .numeroPago,
                        FACTURA:
                          json.data.informacion.facturasClientesWeb[i]
                            .numeroFactura,
                        PRIMA: aMoneda(
                          json.data.informacion.facturasClientesWeb[i].prima,
                          opcionesDolares
                        ),
                        VENCIMIENTO: Moment(
                          json.data.informacion.facturasClientesWeb[i]
                            .fechaDeVencimiento
                        ).format("L"),
                      });
                    } else {
                      if (
                        json.data.informacion.facturasClientesWeb[i]
                          .codigoMoneda == 1 ||
                        json.data.informacion.facturasClientesWeb[i]
                          .codigoMoneda == "1"
                      ) {
                        datos.push({
                          TIPOPOLIZA:
                            json.data.informacion.facturasClientesWeb[i]
                              .tipoPoliza,
                          NUMEROPOLIZA:
                            json.data.informacion.facturasClientesWeb[i]
                              .numeroPoliza,
                          NOMBRE:
                            json.data.informacion.facturasClientesWeb[i].nombre,
                          NUMEROPAGO:
                            json.data.informacion.facturasClientesWeb[i]
                              .numeroPago,
                          FACTURA:
                            json.data.informacion.facturasClientesWeb[i]
                              .numeroFactura,
                          PRIMA: aMoneda(
                            json.data.informacion.facturasClientesWeb[i].prima,
                            opcionesQuetzales
                          ),
                          VENCIMIENTO: Moment(
                            json.data.informacion.facturasClientesWeb[i]
                              .fechaDeVencimiento
                          ).format("L"),
                        });
                      } else {
                        datos.push({
                          TIPOPOLIZA:
                            json.data.informacion.facturasClientesWeb[i]
                              .tipoPoliza,
                          NUMEROPOLIZA:
                            json.data.informacion.facturasClientesWeb[i]
                              .numeroPoliza,
                          NOMBRE:
                            json.data.informacion.facturasClientesWeb[i].nombre,
                          NUMEROPAGO:
                            json.data.informacion.facturasClientesWeb[i]
                              .numeroPago,
                          FACTURA:
                            json.data.informacion.facturasClientesWeb[i]
                              .numeroFactura,
                          PRIMA: aMoneda(
                            json.data.informacion.facturasClientesWeb[i].prima,
                            opcionesDolares
                          ),
                          VENCIMIENTO: Moment(
                            json.data.informacion.facturasClientesWeb[i]
                              .fechaDeVencimiento
                          ).format("L"),
                        });
                      }
                    }
                    tieneDatos = true;
                  }
                }
              }
              if (tieneDatos) {
                const sheet1 = workbook.sheet(0);
                const sheetData = this.getSheetData(datos, header2);
                const totalColumns = sheetData[0].length;
                sheet1.cell("A1").value(sheetData);
                const range = sheet1.usedRange();
                const endColumn = String.fromCharCode(64 + totalColumns);
                sheet1.row(1).style("bold", true);
                sheet1.range("A1:" + endColumn + "1").style("fill", "BFBFBF");
                range.style("border", true);
                return workbook.outputAsync().then((res) => {
                  saveAs(res, "FacturasPendientes_" + clienteReporte + ".xlsx");
                });
              } else {
                swal("Aviso", "No se encontraron datos", "info");
              }
            });
          }
        } else {
          swal("Aviso", "No se encontraron datos", "info");
        }
      })
      .catch(function (error) { });
  }

  updatePolicyActionLayout = () => {
    const actions = document.querySelector(".policy-actions");
    if (!actions) {
      return;
    }

    const visibleCards = Array.from(actions.children).filter((child) => {
      if (child.classList.contains("policy-actions__header")) {
        return false;
      }

      return window.getComputedStyle(child).display !== "none";
    });

    actions.setAttribute("data-card-count", visibleCards.length);
  };

  componentDidMount() {
    setTimeout(this.updatePolicyActionLayout, 0);
    const actions = document.querySelector(".policy-actions");
    if (actions && typeof MutationObserver !== "undefined") {
      this.policyActionsObserver = new MutationObserver(this.updatePolicyActionLayout);
      this.policyActionsObserver.observe(actions, {
        attributes: true,
        attributeFilter: ["style", "class"],
        childList: true,
        subtree: true,
      });
    }

    swal(
      "Se está consultando la información de tus pólizas, por favor espera un momento",
      {
        buttons: false,
        timer: 2000,
      }
    );
    var offset = Moment().utcOffset();
    let fecha_val = sessionStorage.getItem("fechaNac") || $("#hidefecnac").val();
    var localText = Moment.utc(fecha_val).utcOffset(offset).format("L LT");
    let abre_asegu = "";
    const dpi_val = sessionStorage.getItem("dpi") || $("#hidedpi").val();
    var esAsazgua = false;
    if ($("#hdEsAzasgua").val() == "S") {
      esAsazgua = true;
    }
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/polData/` +
        dpi_val +
        "/" +
        Moment.utc(fecha_val).format("YYYY-MM-DD"),
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
          },
        }
      )
      .then((json) => {
        //console.log("Valor de polizas en : ", json.data.polizas)
        if (json.data.polizas.length >= 0) {
          for (var i = 0; i < json.data.polizas.length; i++) {
            if (
              !esAsazgua ||
              (esAsazgua &&
                json.data.polizas[i].polizasPK.numeroPoliza ==
                $("#hdNumPolAzasgua").val())
            ) {
              this.setState({
                aseguradora: json.data.polizas[i].polizasPK.codigoAseguradora,
              });
              if (json.data.polizas[i].polizasPK.codigoAseguradora == "1") {
                abre_asegu = "GRAL";
              } else if (
                json.data.polizas[i].polizasPK.codigoAseguradora == "2"
              ) {
                abre_asegu = "SG&T";
              } else if (
                json.data.polizas[i].polizasPK.codigoAseguradora == "3"
              ) {
                abre_asegu = "ROBLE";
              } else if (
                json.data.polizas[i].polizasPK.codigoAseguradora == "470"
              ) {
                abre_asegu = "BMI";
              } else if (
                json.data.polizas[i].polizasPK.codigoAseguradora == "6"
              ) {
                abre_asegu = "ASSA";
              } else if (
                json.data.polizas[i].polizasPK.codigoAseguradora == "7"
              ) {
                abre_asegu = "CIGNA";
              } else if (
                json.data.polizas[i].polizasPK.codigoAseguradora == "15"
              ) {
                abre_asegu = "MAPFR";
              } else if (
                json.data.polizas[i].polizasPK.codigoAseguradora == "9"
              ) {
                abre_asegu = "SG&T";
              } else if (
                json.data.polizas[i].polizasPK.codigoAseguradora == "10"
              ) {
                abre_asegu = "PALIG";
              } else if (
                json.data.polizas[i].polizasPK.codigoAseguradora == "11"
              ) {
                abre_asegu = "AGRO";
              } else if (
                json.data.polizas[i].polizasPK.codigoAseguradora == "13"
              ) {
                abre_asegu = "UNIV";
              } else if (
                json.data.polizas[i].polizasPK.codigoAseguradora == "16"
              ) {
                abre_asegu = "AFGRA";
              } else if (
                json.data.polizas[i].polizasPK.codigoAseguradora == "17"
              ) {
                abre_asegu = "AFG&T";
              } else if (
                json.data.polizas[i].polizasPK.codigoAseguradora == "18"
              ) {
                abre_asegu = "AFRBL";
              } else if (
                json.data.polizas[i].polizasPK.codigoAseguradora == "50"
              ) {
                abre_asegu = "ASESU";
              } else {
                abre_asegu = "ND";
              }
              this.state.datosramos.push({
                poli: json.data.polizas[i].polizasPK.numeroPoliza,
                rm: json.data.polizas[i].polizasPK.codigoTipoPoliza,
                id: json.data.polizas[i].polizasPK.codigoAseguradora,
                certi: json.data.polizas[i].idepol,
                value: json.data.polizas[i].idepol,
                vCli: json.data.polizas[i].codigoCliente,
                mone: json.data.polizas[i].codigoMoneda.simbolo,
                label:
                  json.data.polizas[i].polizasPK.codigoAseguradora +
                  "-" +
                  abre_asegu +
                  "-" +
                  json.data.polizas[i].polizasPK.numeroPoliza,
                ejecutivoEncargado: json.data.polizas[i].ejecutivoEncargado,
                datosPoliza: json.data.polizas[i]
              });

              this.state.datospoliza.push({
                id: json.data.polizas[i].polizasPK.codigoAseguradora,
                certi: json.data.polizas[i].idCertificado,
                mone: json.data.polizas[i].codigoMoneda.simbolo,
                vCli: json.data.polizas[i].codigoCliente,
                value: json.data.polizas[i].polizasPK.codigoTipoPoliza,
                label:
                  this.getTipoPolizaLabel(json.data.polizas[i].polizasPK.codigoTipoPoliza),
              });
            }
          }
        } else {
          this.setState({
            aseguradora: json.data.polizas.polizasPK.codigoAseguradora,
          });
          if (json.data.polizas.polizasPK.codigoAseguradora == "1") {
            abre_asegu = "GRAL";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == "2") {
            abre_asegu = "SG&T";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == "3") {
            abre_asegu = "ROBLE";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == "470") {
            abre_asegu = "BMI";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == "6") {
            abre_asegu = "ASSA";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == "7") {
            abre_asegu = "CIGNA";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == "15") {
            abre_asegu = "MAPFR";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == "9") {
            abre_asegu = "SG&T";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == "10") {
            abre_asegu = "PALIG";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == "11") {
            abre_asegu = "AGRO";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == "13") {
            abre_asegu = "UNIV";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == "16") {
            abre_asegu = "AFGRA";
          } else if (json.data.polizas[i].polizasPK.codigoAseguradora == "17") {
            abre_asegu = "AFG&T";
          } else if (json.data.polizas[i].polizasPK.codigoAseguradora == "18") {
            abre_asegu = "AFRBL";
          } else if (json.data.polizas[i].polizasPK.codigoAseguradora == "50") {
            abre_asegu = "ASESU";
          } else {
            abre_asegu = "ND";
          }

          this.state.datosramos.push({
            poli: json.data.polizas.polizasPK.numeroPoliza,
            cl: json.data.polizas.codigoCliente,
            rm: json.data.polizas.polizasPK.codigoTipoPoliza,
            id: json.data.polizas.polizasPK.codigoAseguradora,
            certi: json.data.polizas.idepol,
            value: json.data.polizas.idepol,
            mone: json.data.polizas.codigoMoneda.simbolo,
            label:
              abre_asegu +
              "-" +
              json.data.polizas.polizasPK.codigoTipoPoliza +
              "-" +
              json.data.polizas.polizasPK.numeroPoliza,
            ejecutivoEncargado: json.data.polizas.ejecutivoEncargado,
          });

          this.state.datospoliza.push({
            id: json.data.polizas.polizasPK.codigoAseguradora,
            certi: json.data.polizas.idepol,
            value: json.data.polizas.polizasPK.codigoTipoPoliza,
            label:
              this.getTipoPolizaLabel(json.data.polizas.polizasPK.codigoTipoPoliza),
            mone: json.data.polizas.codigoMoneda.simbolo,
          });
        }
      });
    var esAsazgua = false;
    if ($("#hdEsAzasgua").val() == "S") {
      esAsazgua = true;
    }
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/informacion/` +
        dpi_val +
        "/" +
        Moment.utc(fecha_val).format("YYYY-MM-DD"),
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
          },
        }
      )
      .then((json) => {
        if (json.status === 200) {
          let pri_nombre = json.data.primerNombre
            ? json.data.primerNombre
            : json.data.razonSocial;
          let seg_nombre = json.data.segundoNombre
            ? json.data.segundoNombre
            : " ";
          window.infoCliente = pri_nombre;
          $("#idclienteF").val(json.data.idCliente);
          if (json.data.idCliente == 2391) {
            axios
              .get(
                `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/tipos/` +
                $("#idclienteF").val(),
                {
                  headers: {
                    Authorization: `Bearer ${sessionStorage.getItem(
                      "jwtToken"
                    )}`,
                  },
                }
              )
              .then((json) => {
                if (json.data.clientesTipoPoliza.length > 1) {
                  for (
                    var i = 0;
                    i < json.data.clientesTipoPoliza.length;
                    i++
                  ) {
                    this.state.datosit.push({
                      label: this.getTipoPolizaLabel(
                        json.data.clientesTipoPoliza[i].tipo,
                        json.data.clientesTipoPoliza[i].nombre
                      ),
                      value: json.data.clientesTipoPoliza[i].tipo,
                    });
                  }
                } else {
                  this.state.datosit.push({
                    label: this.getTipoPolizaLabel(
                      json.data.clientesTipoPoliza.tipo,
                      json.data.clientesTipoPoliza.nombre
                    ),
                    value: json.data.clientesTipoPoliza.tipo,
                  });
                }
              })
              .catch(function (error) { });
          } else {
            if (!esAsazgua) {
              //console.log("No es asazgua: ",  json.data.primerNombre +" " +seg_nombre +" " +json.data.primerApellido +" " +json.data.segundoApellido);
              this.setState({
                cliente:
                  json.data.primerNombre +
                  " " +
                  seg_nombre +
                  " " +
                  json.data.primerApellido +
                  " " +
                  json.data.segundoApellido,
              });
            }
          }
          setTimeout(function () {
            window.datos = json.data;
          }, 9000);
        } else {
          swal(
            "Error",
            "datos, si no cuentas con usuario puedes crearlo",
            "warning"
          );
        }
      })
      .catch(function (error) { });

    axios
      .get(
        `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/reclamo/` +
        dpi_val +
        "/" +
        Moment.utc(fecha_val).format("YYYY-MM-DD"),
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
          },
        }
      )
      .then((json) => {
        if (json.status === 200) {
          // console.log("REQUEST 2");
          if (json.data.tPolCertificado.length >= 0) {
            //  console.log("AQui: 2");
            $("#simple").val(0);
            for (var i = 0; i < json.data.tPolCertificado.length; i++) {
              this.state.datosramos.push({
                poli: json.data.tPolCertificado[i].idPoliza.numeroPoliza,
                rm: json.data.tPolCertificado[i].idPoliza.idTipoPoliza
                  .codigoTipoPoliza,
                id: json.data.tPolCertificado[i].idPoliza.idAseguradora,
                certi: json.data.tPolCertificado[i].idCertificado,
                value: json.data.tPolCertificado[i].idPoliza.idPoliza,
                mone: json.data.tPolCertificado[i].idPoliza.idMoneda.simbolo,
                mostrarRedAseguradora:
                  json.data.tPolCertificado[i].mostrarRedAseguradora,
                mostrarFormularioCita:
                  json.data.tPolCertificado[i].mostrarFormularioCita,
                mostrarCarnetDigital: json.data.tPolCertificado[i].mostrarCarnetDigital,
                mostrarDocumentos: json.data.tPolCertificado[i].mostrarDocumentos,

                mostrarModuloAsistencias:
                  json.data.tPolCertificado[i].mostrarModuloAsistencias,
                opcionesAsistencias:
                  json.data.tPolCertificado[i].opcionesAsistencias,

                numeroCertificado:
                  json.data.tPolCertificado[i].numeroCertificado,
                numeroPolAseg:
                  json.data.tPolCertificado[i].idPoliza.polizaAseguradora,
                label:
                  json.data.tPolCertificado[i].idPoliza.idAseguradora
                    .abreviatura +
                  "-" +
                  json.data.tPolCertificado[i].idPoliza.idTipoPoliza
                    .codigoTipoPoliza +
                  "-" +
                  json.data.tPolCertificado[i].idPoliza.numeroPoliza,
                datosPoliza: json.data.tPolCertificado[i]
              });
              this.state.datospoliza.push({
                id: json.data.tPolCertificado[i].idPoliza.idAseguradora,
                certi: json.data.tPolCertificado[i].idCertificado,
                value: json.data.tPolCertificado[i].idPoliza.idTipoPoliza,
                label:
                  this.getTipoPolizaLabel(
                    json.data.tPolCertificado[i].idPoliza.idTipoPoliza,
                    json.data.tPolCertificado[i].idPoliza.idTipoPoliza.descripcion
                  ),
              });
              /*console.log(
                "json.data.tPolCertificado[0].idCertificado: ",
                json.data.tPolCertificado[0].idCertificado
              );*/
              axios
                .get(
                  `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/cliente/` +
                  json.data.tPolCertificado[0].idCertificado,
                  {
                    headers: {
                      Authorization: `Bearer ${sessionStorage.getItem(
                        "jwtToken"
                      )}`,
                    },
                  }
                )
                .then((json2) => {
                  //  $('#certificado').val(json.data.tPolCertificado[0].idCertificado);
                  //          $('#idclienteF').val(window.idCliente);
                  let seg_nombre = json.data.segundoNombre
                    ? json.data.segundoNombre
                    : " ";
                  this.setState({
                    cliente:
                      json2.data.primerNombre +
                      " " +
                      seg_nombre +
                      " " +
                      json2.data.primerApellido +
                      " " +
                      (json2.data.segundoApellido ? json2.data.segundoApellido : ''),
                  });
                });

              this.setState({
                aseguradora:
                  json.data.tPolCertificado[i].idPoliza.idAseguradora
                    .idAseguradora,
              });
            }
          } else {/*
            $("#simple").val(1);
            this.setState({
              aseguradora:
                json.data.tPolCertificado.idPoliza.idAseguradora.idAseguradora,
            });
            this.setState({
              poli: json.data.tPolCertificado.idPoliza.numeroPoliza,
            });
            this.state.datosramos.push({
              rm: json.data.tPolCertificado.idPoliza.idTipoPoliza
                .codigoTipoPoliza,
              certi: json.data.tPolCertificado.idCertificado,
              id: json.data.tPolCertificado.idPoliza.idAseguradora
                .idAseguradora,
              value: json.data.tPolCertificado.idPoliza.idPoliza,
              mostrarRedAseguradora:
                json.data.tPolCertificado.mostrarRedAseguradora,
              mostrarFormularioCita:
                json.data.tPolCertificado.mostrarFormularioCita,
               numeroCertificado:
                json.data.tPolCertificado.numeroCertificado,  
                numeroPolAseg:
                json.data.tPolCertificado.idPoliza.polizaAseguradora,    
              mostrarCarnetDigital:json.data.tPolCertificado.mostrarCarnetDigital,  
              label:
                json.data.tPolCertificado.idPoliza.idAseguradora.abreviatura +
                "-" +
                json.data.tPolCertificado.idPoliza.idTipoPoliza
                  .codigoTipoPoliza +
                "-" +
                json.data.tPolCertificado.idPoliza.numeroPoliza,
            });
            this.state.datospoliza.push({
              certi: json.data.tPolCertificado.idCertificado,
              id: json.data.tPolCertificado.idPoliza.idAseguradora
                .idAseguradora,
              value: json.data.tPolCertificado.idPoliza.idTipoPoliza,
              label:
                this.getTipoPolizaLabel(
                  json.data.tPolCertificado.idPoliza.idTipoPoliza,
                  json.data.tPolCertificado.idPoliza.idTipoPoliza.descripcion
                ),
            });

            fetch(
              `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/cliente/` +
                json.data.tPolCertificado.idCertificado,
              {
                headers: {
                  Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
                },
              }
            )
              .then((res) => res.json())
              .then((data) => {
                $("#certificado").val(json.data.tPolCertificado.idCertificado);
                //  $('#idclienteF').val(window.idCliente);
                let seg_nombre = json.data.segundoNombre
                  ? json.data.segundoNombre
                  : " ";
                this.setState({
                  cliente:
                    data.primerNombre +
                    " " +
                    seg_nombre +
                    " " +
                    data.primerApellido +
                    " " +
                    data.segundoApellido,
                });
              });*/
          }
        } else {
          //swal("Error", "Validando informacion General", "warning");
        }
      });
    //}
  }

  getTipoPolizaValue = (tipo) => {
    if (tipo === null || tipo === undefined) {
      return "";
    }

    if (typeof tipo === "string" || typeof tipo === "number") {
      return String(tipo);
    }

    return String(tipo.codigoTipoPoliza || tipo.tipo || tipo.value || "");
  };

  getTipoPolizaNombre = (codigo, fallback = "") => {
    const nombres = {
      GM: "Póliza de Gastos Medicos",
      VD: "Póliza de Vida",
      ACP: "Póliza de Accidentes Personales",
      INCEN: "Póliza de Incendio",
      RC: "Póliza de Responsabilidad Civil",
      TDINCEN: "Póliza de Todo Riesgo",
      CRI: "Póliza de Crimen",
      FA: "Póliza de Fianzas",
      CERT: "Póliza de Certificados",
      EE: "Póliza de Equipo Electronico",
      MM: "Póliza de Maquinaria",
      PD: "Póliza Dental",
      TR: "Póliza De Transporte",
      VA: "Póliza de Vehiculos",
    };

    return fallback || nombres[codigo] || codigo || "ND";
  };

  getTipoPolizaLabel = (codigo, fallback = "") => {
    const valor = this.getTipoPolizaValue(codigo);
    if (fallback && valor && String(fallback).startsWith(`${valor} -`)) {
      return fallback;
    }

    const nombre = this.getTipoPolizaNombre(valor, fallback);
    return valor && nombre ? `${valor} - ${nombre}` : nombre;
  };

  mergeUniquePolicies = (base = [], incoming = []) => {
    const policies = [...base];

    incoming.forEach((policy) => {
      const policyKey = policy.value || policy.certi || policy.poli || policy.label;
      const exists = policies.some((item) => {
        const itemKey = item.value || item.certi || item.poli || item.label;
        return String(itemKey) === String(policyKey);
      });

      if (!exists) {
        policies.push(policy);
      }
    });

    return policies;
  };

  handleChangeTi = (selectedOptionit) => {
    const tipoSeleccionado = this.getTipoPolizaValue(selectedOptionit.value);
    const opcionesBase = this.state.datosramosTodos.length
      ? this.state.datosramosTodos
      : this.state.datosramos || [];
    const polizasFiltradas = opcionesBase.filter(
      (poliza) => this.getTipoPolizaValue(poliza.rm) === tipoSeleccionado
    );
    this.setState({
      selectedOptionit,
      selectedOptionRam: null,
      tipPoliza: selectedOptionit.label,
      tipPolizaCodigo: tipoSeleccionado,
      datosramosTodos: opcionesBase,
      datosramos: polizasFiltradas,
    });
    $("#tipoPol").val(tipoSeleccionado);
    swal(
      "Se estan consultando tu información general, por favor espera un momento",
      {
        buttons: false,
        timer: 2000,
      }
    );
    let fecha_val = sessionStorage.getItem("fechaNac") || $("#hidefecnac").val();
    //var localText = Moment.utc(fecha_val).utcOffset(offset).format("L LT");
    let abre_asegu = "";
    const dpi_val_ti = sessionStorage.getItem("dpi") || $("#hidedpi").val();

    $("#id_ram").val(tipoSeleccionado);
    $("#tip_ram").val(selectedOptionit.label);

    this.setState({ idRam: tipoSeleccionado });
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/polData/` +
        dpi_val_ti +
        "/" +
        Moment.utc(fecha_val).format("YYYY-MM-DD"),
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
          },
        }
      )
      .then((json) => {
        const datosramos = [];
        const datospoliza = [];
        if (json.data.polizas.length >= 0) {
          for (var i = 0; i < json.data.polizas.length; i++) {
            this.setState({
              aseguradora: json.data.polizas[i].polizasPK.codigoAseguradora,
            });
            if (json.data.polizas[i].polizasPK.codigoAseguradora == 1) {
              abre_asegu = "GRAL";
            } else if (json.data.polizas[i].polizasPK.codigoAseguradora == 2) {
              abre_asegu = "SG&T";
            } else if (json.data.polizas[i].polizasPK.codigoAseguradora == 3) {
              abre_asegu = "ROBLE";
            } else if (
              json.data.polizas[i].polizasPK.codigoAseguradora == 470
            ) {
              abre_asegu = "BMI";
            } else if (json.data.polizas[i].polizasPK.codigoAseguradora == 6) {
              abre_asegu = "ASSA";
            } else if (json.data.polizas[i].polizasPK.codigoAseguradora == 7) {
              abre_asegu = "CIGNA";
            } else if (json.data.polizas[i].polizasPK.codigoAseguradora == 15) {
              abre_asegu = "MAPFR";
            } else if (json.data.polizas[i].polizasPK.codigoAseguradora == 9) {
              abre_asegu = "SG&T";
            } else if (json.data.polizas[i].polizasPK.codigoAseguradora == 10) {
              abre_asegu = "PALIG";
            } else if (json.data.polizas[i].polizasPK.codigoAseguradora == 11) {
              abre_asegu = "AGRO";
            } else if (json.data.polizas[i].polizasPK.codigoAseguradora == 13) {
              abre_asegu = "UNIV";
            } else if (json.data.polizas[i].polizasPK.codigoAseguradora == 16) {
              abre_asegu = "AFGRA";
            } else if (json.data.polizas[i].polizasPK.codigoAseguradora == 17) {
              abre_asegu = "AFG&T";
            } else if (json.data.polizas[i].polizasPK.codigoAseguradora == 18) {
              abre_asegu = "AFRBL";
            } else if (json.data.polizas[i].polizasPK.codigoAseguradora == 50) {
              abre_asegu = "ASESU";
            } else {
              abre_asegu = "ND";
            }

            if (
              tipoSeleccionado ===
              this.getTipoPolizaValue(json.data.polizas[i].polizasPK.codigoTipoPoliza)
            ) {
              datosramos.push({
                poli: json.data.polizas[i].polizasPK.numeroPoliza,
                rm: json.data.polizas[i].polizasPK.codigoTipoPoliza,
                id: json.data.polizas[i].polizasPK.codigoAseguradora,
                certi: json.data.polizas[i].idepol,
                value: json.data.polizas[i].idepol,
                vCli: json.data.polizas[i].codigoCliente,
                mone: json.data.polizas[i].codigoMoneda.simbolo,
                label:
                  json.data.polizas[i].polizasPK.codigoAseguradora +
                  "-" +
                  abre_asegu +
                  "-" +
                  json.data.polizas[i].polizasPK.numeroPoliza,
                ejecutivoEncargado: json.data.polizas[i].ejecutivoEncargado,
                datosPoliza: json.data.polizas[i]
              });
            }

            datospoliza.push({
              id: json.data.polizas[i].polizasPK.codigoAseguradora,
              certi: json.data.polizas[i].idCertificado,
              mone: json.data.polizas[i].codigoMoneda.simbolo,
              vCli: json.data.polizas[i].codigoCliente,
              value: json.data.polizas[i].polizasPK.codigoTipoPoliza,
              label:
                this.getTipoPolizaLabel(json.data.polizas[i].polizasPK.codigoTipoPoliza),
            });
          }
        } else {
          this.setState({
            aseguradora: json.data.polizas.polizasPK.codigoAseguradora,
          });
          if (json.data.polizas.polizasPK.codigoAseguradora == 1) {
            abre_asegu = "GRAL";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == 2) {
            abre_asegu = "SG&T";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == 3) {
            abre_asegu = "ROBLE";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == 470) {
            abre_asegu = "BMI";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == 6) {
            abre_asegu = "ASSA";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == 7) {
            abre_asegu = "CIGNA";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == 15) {
            abre_asegu = "MAPFR";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == 9) {
            abre_asegu = "SG&T";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == 10) {
            abre_asegu = "PALIG";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == 11) {
            abre_asegu = "AGRO";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == 13) {
            abre_asegu = "UNIV";
          } else if (json.data.polizas.polizasPK.codigoAseguradora == 16) {
            abre_asegu = "AFGRA";
          } else if (json.data.polizas[i].polizasPK.codigoAseguradora == 17) {
            abre_asegu = "AFG&T";
          } else if (json.data.polizas[i].polizasPK.codigoAseguradora == 18) {
            abre_asegu = "AFRBL";
          } else if (json.data.polizas[i].polizasPK.codigoAseguradora == 50) {
            abre_asegu = "ASESU";
          } else {
            abre_asegu = "ND";
          }

          datosramos.push({
            poli: json.data.polizas.polizasPK.numeroPoliza,
            cl: json.data.polizas.codigoCliente,
            rm: json.data.polizas.polizasPK.codigoTipoPoliza,
            id: json.data.polizas.polizasPK.codigoAseguradora,
            certi: json.data.polizas.idepol,
            value: json.data.polizas.idepol,
            mone: json.data.polizas.codigoMoneda.simbolo,
            label:
              abre_asegu +
              "-" +
              json.data.polizas.polizasPK.codigoTipoPoliza +
              "-" +
              json.data.polizas.polizasPK.numeroPoliza,
            ejecutivoEncargado: json.data.polizas.ejecutivoEncargado,
          });

          datospoliza.push({
            id: json.data.polizas.polizasPK.codigoAseguradora,
            certi: json.data.polizas.idepol,
            value: json.data.polizas.polizasPK.codigoTipoPoliza,
            label:
              this.getTipoPolizaLabel(json.data.polizas.polizasPK.codigoTipoPoliza),
            mone: json.data.polizas.codigoMoneda.simbolo,
          });
        }
        this.setState((prevState) => {
          const datosramosTodos = this.mergeUniquePolicies(
            prevState.datosramosTodos.length ? prevState.datosramosTodos : opcionesBase,
            datosramos
          );
          const datospolizaTodos = this.mergeUniquePolicies(
            prevState.datospoliza,
            datospoliza
          );

          return {
            datosramos: datosramos.length ? datosramos : polizasFiltradas,
            datosramosTodos,
            datospoliza: datospolizaTodos,
          };
        });
      });
  };

  handleChangeRam = (selectedOptionRam) => {
    console.log("Valor de selectedOptionRam.value: ", selectedOptionRam);
    $("#monedaPol").val(selectedOptionRam.mone);
    // console.log("$(#hdEsAzasgua).val()", $("#hdEsAzasgua").val());
    // console.log('$("#hdClienteActual").val()', $("#hdClienteActual").val());
    sessionStorage.setItem(
      "ejecutivoEncargado",
      selectedOptionRam.ejecutivoEncargado
    );
    sessionStorage.setItem("numeroPolizaAseg", selectedOptionRam.numeroPolAseg);
    sessionStorage.setItem("tipoPolizaCodigo", selectedOptionRam.rm);
    window.tipoPolizaCodigo = selectedOptionRam.rm;
    const idPoliza =
      selectedOptionRam?.datosPoliza?.idPoliza?.idPoliza ||
      selectedOptionRam?.datosPoliza?.idepol ||
      selectedOptionRam?.value;
    const codigoAseguradora =
      selectedOptionRam?.datosPoliza?.idPoliza?.idAseguradora?.idAseguradora ||
      selectedOptionRam?.datosPoliza?.polizasPK?.codigoAseguradora ||
      selectedOptionRam?.id?.idAseguradora ||
      selectedOptionRam?.id;

    window.idPoliza = idPoliza;
    sessionStorage.setItem("numeroCertificado", selectedOptionRam.numeroCertificado);
    // Además de sessionStorage (que ya lee el resto de la app), se notifica
    // al AseguradoraContext para que componentes reactivos como Footer.js
    // se actualicen solos al cambiar de póliza/aseguradora, sin necesidad
    // de un reload — antes este cambio quedaba "atrapado" en sessionStorage
    // y nada más en la app se enteraba de él.
    this.context.establecerCodigoAseguradora(codigoAseguradora);
    let valRam;
    let clienteSel =
      $("#hdEsAzasgua").val() == "S"
        ? $("#hdClienteActual").val()
        : selectedOptionRam.vCli;
    // console.log("clienteSel: ", clienteSel);
    $("#polizaCompleta").val(selectedOptionRam.label);
    $("#idepol").val(selectedOptionRam.value);
    $("#idclienteU").val(selectedOptionRam.vCli);
    if (selectedOptionRam.vCli) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/estado/` +
          $("#idepol").val() +
          "/" +
          clienteSel,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
            },
          }
        )
        .then((json) => {
          if (json.status === 200) {
            if (json.data.facturasClientesWeb.length > 0) {
              this.setState({
                cliente: json.data.facturasClientesWeb[0].nombre,
              });
            } else {
              this.setState({
                cliente: json.data.facturasClientesWeb.nombre,
              });
            }
          } else {
            swal("Error", "La póliza no cuenta con facturas registradas.", "info");
          }
        })
        .catch(function (error) {
          //swal("Atención", "La póliza no cuenta con facturas pendientes ni tampoco pagadas Inicio", "warning");
        });
    }
    this.setState({ numeroPoliza: selectedOptionRam.poli });
    this.setState({ monedaPol: selectedOptionRam.mone });
    switch (selectedOptionRam.rm) {
      case "GM":
        this.setState({ tipPoliza: "Póliza de Gastos Medicos" });
        this.setState({ tipPolizaCodigo: "GM" });
        break;
      case "VD":
        this.setState({ tipPoliza: "Póliza de Vida" });
        this.setState({ tipPolizaCodigo: "VD" });
        break;
      case "ACP":
        this.setState({ tipPoliza: "Póliza de Accidentes Personales" });
        this.setState({ tipPolizaCodigo: "ACP" });
        break;
      case "INCEN":
        this.setState({ tipPoliza: "Póliza de Incendio" });
        this.setState({ tipPolizaCodigo: "INCEN" });
        break;
      case "RC":
        this.setState({ tipPoliza: "Póliza de Responsabilidad Civil" });
        this.setState({ tipPolizaCodigo: "RC" });
        break;
      case "TDINCEN":
        this.setState({ tipPoliza: "Póliza de Todo Riesgo" });
        this.setState({ tipPolizaCodigo: "TDINCEN" });
        break;
      case "CRI":
        this.setState({ tipPoliza: "Póliza de Crimen" });
        this.setState({ tipPolizaCodigo: "CRI" });
        break;
      case "FA":
        this.setState({ tipPoliza: "Póliza de Fianzas" });
        this.setState({ tipPolizaCodigo: "FA" });
        break;
      case "CERT":
        this.setState({ tipPoliza: "Póliza de Certificados" });
        this.setState({ tipPolizaCodigo: "CERT" });
        break;
      case "EE":
        this.setState({ tipPoliza: "Póliza de Equipo Electronico" });
        this.setState({ tipPolizaCodigo: "EE" });
        break;
      case "MM":
        this.setState({ tipPoliza: "Póliza de Maquinaria" });
        this.setState({ tipPolizaCodigo: "MM" });
        break;
      case "PD":
        this.setState({ tipPoliza: "Póliza Dental" });
        this.setState({ tipPolizaCodigo: "PD" });
        break;
      case "TR":
        this.setState({ tipPoliza: "Póliza De Transporte" });
        this.setState({ tipPolizaCodigo: "TR" });
        break;
      case "VA":
        this.setState({ tipPoliza: "Póliza de Vehiculos" });
        this.setState({ tipPolizaCodigo: "VA" });
        break;

      default:
        this.setState({ tipPoliza: "ND" });
    }

    // obtenemos el numero de cabina    
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/getParametrosGeneralesAPP/CONTACTENOS?pais=`+sessionStorage.getItem('paisCliente'),
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
          },
        }
      )
      .then((json) => {
        if (json.status === 200) {
          console.log(selectedOptionRam.datosPoliza.ejecutivoEncargado);
          if (
            (selectedOptionRam.rm === "GM" ||
            selectedOptionRam.rm === "PD" ||
            selectedOptionRam.rm === "ACP" ||
            selectedOptionRam.rm === "VD") && (selectedOptionRam.datosPoliza.ejecutivoEncargado!= "RP")
          ) {
            const telCabinaGM = json.data.ParametrosAppSomit.find(
              (p) => p.nombreParametro === "NumeroEmergenciaGM"
            );
            $("#phEmergencia").attr(
              "href",
              "tel:" +
              telCabinaGM?.valorParametro
            );
            $('#miImagenCabina').attr('src', 'https://miseguro.somit.com/imagenes/cabinaGM2.png');
            this.state.numeroTelefonoCabina = telCabinaGM?.valorParametro;
            //this.state.telefonoCab=telCabinaGM?.valorParametro;
            $("#spNumCabina").text(telCabinaGM?.valorParametro);
            $("#btnEmergencia").show();
          } else if (  (
    selectedOptionRam.rm === "GM" ||
    selectedOptionRam.rm === "PD" ||
    selectedOptionRam.rm === "ACP" ||
    selectedOptionRam.rm === "VD"
  ) &&
  selectedOptionRam.datosPoliza.ejecutivoEncargado === "RP"
) {
  console.log("cabina rp");
            const telCabinaGM = json.data.ParametrosAppSomit.find(
              (p) => p.nombreParametro === "RP"
            );
            $("#phEmergencia").attr(
              "href",
              "tel:" +
              telCabinaGM?.valorParametro
            );
            console.log(telCabinaGM?.valorParametro);
                        $('#miImagenCabina').attr('src', 'https://miseguro.somit.com/imagenes/cabinaGM2.png');
            this.state.numeroTelefonoCabina = telCabinaGM?.valorParametro;
            //this.state.telefonoCab=telCabinaGM?.valorParametro;
            $("#spNumCabina").text(telCabinaGM?.valorParametro);
            $("#btnEmergencia").show();
          }else {

            const telCabinaDanios = json.data.ParametrosAppSomit.find(
              (p) => p.nombreParametro === "NumeroCabinaSomit"
            );
            $("#phEmergencia").attr(
              "href",
              "tel:" +
              telCabinaDanios?.valorParametro
            );
            //this.state.telefonoCab=telCabinaGM?.valorParametro;
            this.state.numeroTelefonoCabina = telCabinaDanios?.valorParametro;
            $("#spNumCabina").text(telCabinaDanios?.valorParametro);
            $('#miImagenCabina').attr('src', 'https://miseguro.somit.com/imagenes/cabinaDanios.png');
            $("#btnEmergencia").show();
          }
        }
      })
      .catch(function (error) { });

    let registro_aseguradora = 0;
    if (
      selectedOptionRam.rm === "GM" ||
      selectedOptionRam.rm === "PD" ||
      selectedOptionRam.rm === "ACP" ||
      selectedOptionRam.rm === "VD"
    ) {
      sessionStorage.setItem(
        "mostrarDocumentos",
        selectedOptionRam.mostrarDocumentos
      );
      //mostramos la opción de red de proveedores de la aseguradora general y si la póliza tiene habilitado
      // la bandera mostrarRedAseguradora=1 entonces que muestre la opcion de red de proveedores
      if (
        //selectedOptionRam.id.idAseguradora == 1 && se comenta porque ahora ya mas aseguradoras
        selectedOptionRam.mostrarRedAseguradora == 1
      ) {
        // guardo en sesion si se debe mostrar el formulario de citas
        sessionStorage.setItem(
          "mostrarFormularioCita",
          selectedOptionRam.mostrarFormularioCita
        );



        $("#dvRedProveedores").show();

      } else {
        $("#dvRedProveedores").hide();
      }

      //Este if es para mostrar o no el carnet digital de la aseguradora general        
      if (selectedOptionRam.mostrarCarnetDigital == 1) {

        $("#divCarnetDigital").show();
      } else {
        $("#divCarnetDigital").hide();
      }

      // Esta bandera es para mostrar las opciones de las asistencias
      if (selectedOptionRam.mostrarModuloAsistencias == 1) {
        const telefono = selectedOptionRam.opcionesAsistencias.find(
          (item) => item.nombreParametro === "NUMERO_TELEFONO"
        );
        this.state.numeroTelefonoAsis = telefono?.valorParametro;
        $("#divModuloAsistencias").show();

      } else {
        $("#divModuloAsistencias").hide();
      }

      this.setState({ valDanos: 0 });

      // $("#asegu").val(selectedOptionRam.id.idAseguradora);

      $("#certificado").val(selectedOptionRam.certi);
      this.setState({ selectedOptionRam });

      valRam = selectedOptionRam.value;

      axios
        .get(
          `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/cartera/` +
          valRam,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
            },
          }
        )
        .then((json3) => {
          //console.log("json3.data.idCartera: ",json3.data.idCartera);
          if (json3.data.idCartera !== 3  && json3.data.idCartera !== 13) {
            //console.log("ingrese a individual");
            $("#cuenta").removeClass();
            $("#poliza").removeClass();
            $("#gestiones").removeClass();
            $("#asesor").removeClass();
            $("#cuenta").show();
            $("#gestiones").show();
            $("#cuenta").addClass("col-xs-12 col-md-3");
            $("#poliza").addClass("col-xs-12 col-md-2");
            $("#gestiones").addClass("col-xs-12 col-md-2");
            $("#asesor").addClass("col-xs-12 col-md-2");
          } else {
            //console.log("ingrese a colectivos");
            $("#cuenta").removeClass();
            $("#poliza").removeClass();
            $("#gestiones").removeClass();
            $("#infoasegu").removeClass();
            $("#asesor").removeClass();
            $("#cuenta").hide();
            $("#gestiones").show();
            $("#poliza").addClass("col-xs-12 col-md-3");
            $("#infoasegu").addClass("col-xs-12 col-md-3");
            $("#gestiones").addClass("col-xs-12 col-md-3");
            $("#asesor").addClass("col-xs-12 col-md-3");
          }
        });
      //console.log('$("#simple").val() ',$("#simple").val());
      if ($("#simple").val() === "0") {
        //console.log("ingreso a simple");
        registro_aseguradora = selectedOptionRam.id.idAseguradora;
        //console.log("ingreso a simple" + registro_aseguradora);
      } else {
        registro_aseguradora = this.state.aseguradora;
        //console.log("ingreso a normal" + registro_aseguradora);
      }

      //console.log("registro_aseguradora: ", registro_aseguradora);

      $("#ag").empty();
      $("#ag").append("Aseguradora");

       this.setState({
            imag: selectedOptionRam.datosPoliza.idPoliza.idAseguradora.urlLogo,
          });
          return $("#asegus")
            .attr("href", selectedOptionRam.datosPoliza.idPoliza.idAseguradora.enlace)
            .attr("target", "_blank");

            
      //console.log("registro_aseguradora: ", String(registro_aseguradora));
      /*switch (String(registro_aseguradora)) {
        case "1":
          this.setState({
            imag: a1,
          });
          return $("#asegus")
            .attr("href", "https://www.aseguradorageneral.com/formularios")
            .attr("target", "_blank");

        case "2":
          this.setState({
            imag: a2,
          });

          return $("#asegus")
            .attr("href", "https://segurosgyt.com.gt/descargas")
            .attr("target", "_blank");

        case "3":
          this.setState({
            imag: a3,
          });

          return $("#asegus")
            .attr("href", "https://www.elroble.com/guias-y-formularios/")
            .attr("target", "_blank");
        case "6":
          this.setState({
            imag: a6,
          });
          return $("#asegus")
            .attr("href", "https://www.assanet.com.gt/reclamos/formularios/")
            .attr("target", "_blank");

        case "7":
          this.setState({
            imag: a7,
          });
          return $("#asegus")
            .attr(
              "href",
              "https://www.mapfre.com.gt/formularios-gastos-medicos/"
            )
            .attr("target", "_blank");

        case "8":
          this.setState({
            imag: a8,
          });
          return $("#asegus")
            .attr(
              "href",
              "https://www.ficohsa.com/seguros/formularios/formularios-banco-ficohsa/"
            )
            .attr("target", "_blank");

        case "13":
          this.setState({
            imag: a13,
          });
          return $("#asegus")
            .attr("href", "https://www.universales.com/")
            .attr("target", "_blank");

        case "15":
          this.setState({
            imag: a7,
          });
          return $("#asegus")
            .attr(
              "href",
              "https://www.mapfre.com.gt/formularios-gastos-medicos/"
            )
            .attr("target", "_blank");

        case "28":
          this.setState({
            imag: a28,
          });

          return $("#asegus")
            .attr("href", "https://bmi.gt/descargas/formularios/")
            .attr("target", "_blank");

        case "12":
          this.setState({
            imag: a12,
          });
          return $("#asegus")
            .attr("href", "https://www.aseguate.com/index.php")
            .attr("target", "_blank");

        case "10":
          this.setState({
            imag: a10,
          });
          return $("#asegus")
            .attr("href", "https://www.palig.com/es/guatemala/home/forms")
            .attr("target", "_blank");

        case "11":
          //console.log("agro");
          this.setState({
            imag: a11,
          });
          return $("#asegus")
            .attr("href", "https://www.bam.com.gt/seguros-agromercantil/")
            .attr("target", "_blank");
        case "16":
          //console.log("agro");
          this.setState({
            imag: a1,
          });
          return $("#asegus")
            .attr("href", "https://www.aseguradorageneral.com/formularios")
            .attr("target", "_blank");

        case "630":
          this.setState({
            imag: a630,
          });
          return $("#asegus")
            .attr(
              "href",
              "https://www.bupasalud.com.gt/individuos/centro-de-bienvenida/clientes-individuales/documentos-de-poliza"
            )
            .attr("target", "_blank");

        default:
          return "hola";
      }*/
    } else {
      //  $('#idclienteF').val(selectedOptionRam.cl);
      $("#divCarnetDigital").hide();
      $("#dvRedProveedores").hide();
      $("#divModuloAsistencias").hide();
      this.setState({ valDanos: 1 });
      $("#certificado").val(selectedOptionRam.certi);
      $("#monedaPol").val(selectedOptionRam.mone);
      this.setState({ selectedOptionRam });
      //console.log(selectedOptionRam.certi);
      //console.log(selectedOptionRam.mone);
      valRam = selectedOptionRam.value;
      $("#asegu").val(selectedOptionRam.id);
      //console.log(selectedOptionRam.id);
      $("#cuenta").removeClass();
      $("#infoasegu").removeClass();
      $("#poliza").removeClass();
      $("#gestiones").removeClass();
      $("#asesor").removeClass();
      $("#cuenta").show();
      $("#gestiones").hide();
      $("#infoasegu").addClass("col-xs-12 col-md-3");
      $("#cuenta").addClass("col-xs-12 col-md-3");
      $("#poliza").addClass("col-xs-12 col-md-3");
      $("#asesor").addClass("col-xs-12 col-md-3");

      //console.log("ingreso a simple");
      registro_aseguradora = selectedOptionRam.id;
      //console.log("ingreso a simple" + registro_aseguradora);

      $("#asegus").removeAttr("href");
      //$("#phEmergencia").removeAttr("href");


      //console.log("ingrese a vehiculos" + registro_aseguradora);
      $("#ag").empty();
      $("#ag").append("Aseguradora"); 

       this.setState({
            imag: selectedOptionRam.datosPoliza.aseguradora.urlLogoAseguradora,
          });
          return $("#asegus")
            .attr("href", selectedOptionRam.datosPoliza.aseguradora.webSite)
            .attr("target", "_blank");
      
      
      /*
      switch (String(registro_aseguradora)) {
        case "1":
          this.setState({
            imag: a1,
          });

          return $("#asegus").attr("onClick", "this.showModal(5)");

        case "2":
          this.setState({
            imag: a2,
          });
          //break;
          return $("#asegus").attr("onClick", "this.showModal(5)");

        case "3":
          this.setState({
            imag: a3,
          });
          //break;
          return $("#asegus").attr("onClick", "this.showModal(5)");

        case "6":
          this.setState({
            imag: a6,
          });
          //break;
          return $("#asegus").attr("onClick", "this.showModal(5)");

        case "7":
          this.setState({
            imag: a7,
          });
          //break;
          return $("#asegus").attr("onClick", "this.showModal(5)");

        case "15":
          this.setState({
            imag: a15,
          });
          //break;
          return $("#asegus").attr("onClick", "this.showModal(5)");   

        case "8":
          this.setState({
            imag: a8,
          });
          //break;
          return $("#asegus").attr("onClick", "this.showModal(5)");

        case "13":
          this.setState({
            imag: a13,
          });
          //break;
          return $("#asegus").attr("onClick", "this.showModal(5)");
        case "28":
          this.setState({
            imag: a28,
          });
          //break;
          return $("#asegus").attr("onClick", "this.showModal(5)");

        case "12":
          this.setState({
            imag: a12,
          });
          //break;
          return $("#asegus").attr("onClick", "this.showModal(5)");

        case "10":
          this.setState({
            imag: a10,
          });
          //break;
          return $("#asegus").attr("onClick", "this.showModal(5)");

        case "11":
          //console.log("agro");
          this.setState({
            imag: a11,
          });
          //break;
          return $("#asegus").attr("onClick", "this.showModal(5)");
        case "16":
          //console.log("agro");
          this.setState({
            imag: a1,
          });
          //break;
          return $("#asegus").attr("onClick", "this.showModal(5)");
        case "16":
          //console.log("fianza roble");
          this.setState({
            imag: a1,
          });
          //break;
          return $("#asegus").attr("onClick", "this.showModal(5)");
        case "17":
          //console.log("fianza gyt");
          this.setState({
            imag: a2,
          });
          //break;
          return $("#asegus").attr("onClick", "this.showModal(5)");
        case "18":
          //console.log("fianza roble");
          this.setState({
            imag: a3,
          });
          //break;
          return $("#asegus").attr("onClick", "this.showModal(5)");
        case "630":
          this.setState({
            imag: a630,
          });
          //break;
          return $("#asegus").attr("onClick", "this.showModal(5)");

        default:
          return "hola";
      }*/

      /*switch (String(registro_aseguradora)) {
        case "1":
          this.setState({
            imag: a1,
          });
          return $("#asegus")
            .attr("href", "https://www.aseguradorageneral.com/formularios")
            .attr("target", "_blank");

        case "2":
          this.setState({
            imag: a2,
          });

          return $("#asegus")
            .attr("href", "https://segurosgyt.com.gt/descargas")
            .attr("target", "_blank");

        case "3":
          this.setState({
            imag: a3,
          });

          return $("#asegus")
            .attr("href", "https://www.elroble.com/guias-y-formularios/")
            .attr("target", "_blank");
        case "6":
          this.setState({
            imag: a6,
          });
          return $("#asegus")
            .attr("href", "https://www.assanet.com.gt/reclamos/formularios/")
            .attr("target", "_blank");

        case "7":
          this.setState({
            imag: a7,
          });
          return $("#asegus")
            .attr(
              "href",
              "https://www.mapfre.com.gt/formularios-gastos-medicos/"
            )
            .attr("target", "_blank");

        case "8":
          this.setState({
            imag: a8,
          });
          return $("#asegus")
            .attr(
              "href",
              "https://www.ficohsa.com/seguros/formularios/formularios-banco-ficohsa/"
            )
            .attr("target", "_blank");

        case "13":
          this.setState({
            imag: a13,
          });
          return $("#asegus")
            .attr("href", "https://www.universales.com/")
            .attr("target", "_blank");

        case "15":
          this.setState({
            imag: a7,
          });
          return $("#asegus")
            .attr(
              "href",
              "https://www.mapfre.com.gt/formularios-gastos-medicos/"
            )
            .attr("target", "_blank");

        case "28":
          this.setState({
            imag: a28,
          });

          return $("#asegus")
            .attr("href", "https://bmi.gt/descargas/formularios/")
            .attr("target", "_blank");

        case "12":
          this.setState({
            imag: a12,
          });
          return $("#asegus")
            .attr("href", "https://www.aseguate.com/index.php")
            .attr("target", "_blank");

        case "10":
          this.setState({
            imag: a10,
          });
          return $("#asegus")
            .attr("href", "https://www.palig.com/es/guatemala/home/forms")
            .attr("target", "_blank");

        case "11":
          //console.log("agro");
          this.setState({
            imag: a11,
          });
          return $("#asegus")
            .attr("href", "https://www.bam.com.gt/seguros-agromercantil/")
            .attr("target", "_blank");
        case "16":
          //console.log("agro");
          this.setState({
            imag: a1,
          });
          return $("#asegus")
            .attr("href", "https://www.aseguradorageneral.com/formularios")
            .attr("target", "_blank");

        case "630":
          this.setState({
            imag: a630,
          });
          return $("#asegus")
            .attr(
              "href",
              "https://www.bupasalud.com.gt/individuos/centro-de-bienvenida/clientes-individuales/documentos-de-poliza"
            )
            .attr("target", "_blank");

        default:
          return "hola";
      }*/
    }
  };

  showModal = (valor) => {
    var registroU = 0;
    var registroF = 0;
    //console.log("llegue:::" + $("#idclienteU").val());
    if ($("#idclienteU").val() == "" || $("#idclienteU").val() == undefined) {
      registroU = 1;
    }

    if ($("#idclienteF").val() == "" || $("#idclienteF").val() == undefined) {
      registroF = 1;
    }

    if (
      (registroU == 1 || registroU == undefined) &&
      (registroF == 1 || registroF == undefined)
    ) {
      swal(
        "Atención",
        "Para consultar algún dato debes de seleccionar previamente una póliza.",
        "warning"
      );
    } else {
      if (valor === 1) {
        $("#datGen").hide();
        $("#datGen").hide();
        if (this.state.valDanos === 0) {
          this.setState({ titulo: "Información General" });
          this.setState({ ventana: Poliza });
          this.setState({ show: true });
          window.nomTitular = $("#nombreT").text();
        } else {
          this.setState({ titulo: "Información General" });
          this.setState({ ventana: PolizaDanos });
          this.setState({ show: true });
        }
      } else if (valor === 2) {
        $("#datGen").hide();
        $("#datGen").hide();
        this.setState({ titulo: "Información Asesores" });
        this.setState({ ventana: Asesor });
        this.setState({ show: true });
      } else if (valor === 4) {
        $("#datGen").hide();
        $("#datGen").hide();
        this.setState({ titulo: "Gestiones Digitales" });
        this.setState({ ventana: gestiones });
        this.setState({ show: true });
      } else if (valor === 5) {
        $("#datGen").hide();
        $("#datGen").hide();
        this.setState({ titulo: "Información Reclamos" });
        //this.setState({ ventana: gestion_reclamo });
        this.setState({ ventana: gestion_reclamo });
        //this.setState({ ventana: bitacora_reclamo });

        if (
          $("#tipoPol").val() === "VA" ||
          $("#tipoPol").val() === "CERT" ||
          $("#tipoPol").val() === "MM" ||
          $("#tipoPol").val() === "EE" ||
          $("#tipoPol").val() === "TR" ||
          $("#tipoPol").val() === "INCEN" ||
          $("#tipoPol").val() === "TDINCEN" ||
          $("#tipoPol").val() === "CRI" ||
          $("#tipoPol").val() === "FA" ||
          $("#tipoPol").val() === "RC"
        ) {
          this.setState({ show: true });
        } else {
          this.setState({ show: false });
        }
      } else if (valor === 4) {
        $("#datGen").hide();
        $("#datGen").hide();
        this.setState({ titulo: "Gestiones Digitales" });
        this.setState({ ventana: gestiones });
        this.setState({ show: true });
      } else if (valor === 6) {
        // para mostrar los proveedores de la aseguradora general
        this.setState({ titulo: "Red de Proveedores" });
        this.setState({ ventana: "RED_PROVEEDORES" });
        this.setState({ show: true });
      } else if (valor === 7) {
        // para mostrar el carnet digital
        this.setState({ titulo: "Carné digital" });
        this.setState({ ventana: CarnetDigital });
        this.setState({ show: true });
      } else {
        $("#datGen").hide();
        $("#datGen").hide();
        this.setState({ titulo: "Información Estado de Cuenta" });
        this.setState({ ventana: TablaCuenta });
        this.setState({ show: true });
      }
    }
  };

  hideModal = () => {
    this.setState({ show: false });
    $("#valPrin").val(2);
  };

  toggle1() {
    this.setState({
      collapse: !this.state.collapse,
    });
  }

  toggleFade1() {
    this.setState((prevState) => {
      return {
        fadeIn: !prevState,
      };
    });
  }

  componentWillUnmount() {
    if (this.policyActionsObserver) {
      this.policyActionsObserver.disconnect();
    }
  }

  render() {
    const pol = this.state.datospoliza;
    const { selectedOptionRam } = this.state;
    const { selectedOptionit } = this.state;
    const pol_ram = this.state.datosramos;
    const itip = this.state.datosit.length
      ? this.state.datosit.map((item) => ({
        ...item,
        value: this.getTipoPolizaValue(item.value),
      }))
      : this.state.datospoliza.reduce((options, item) => {
        const value = this.getTipoPolizaValue(item.value);
        if (!options.some((option) => option.value === value)) {
          options.push({ label: this.getTipoPolizaLabel(value, item.label), value });
        }
        return options;
      }, []);
    const selectStyles = {
      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    };
    return (
      <div className="dashboard-panel">
        <Modal
          className="somit-modal"
          size="xl"
          show={this.state.show}
          onHide={this.hideModal}
          backdrop="static" // Impide cerrar al hacer clic fuera del modal
          keyboard={false} // Impide cerrar al presionar "Esc"
        >
          <Modal.Header
            className="somit-modal__header"
            style={{ background: "#003479", color: "white" }}
            closeButton
            closeVariant="white"
          >
            <Modal.Title>{this.state.titulo}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="somit-modal__body">
            <div
              style={{
                backgroundColor: "",
                padding: "0",
                borderRadius: "12px",
              }}
            >
              <div id="datGen" name="datGen" style={{ display: "none" }}>
                <h3>Suma Asegurada:</h3>{" "}
                <Input type="text" id="monto" name="monto" disabled />
                <h3>Vigencia de Poliza:</h3>{" "}
                <Input type="text" id="vigPol" name="vigPol" disabled />
              </div>
               {
                  this.state.ventana === "RED_PROVEEDORES"
                    ? (
                        <RedProveedores
                          datosramos={this.state.datosramos}                          
                        />
                      )
                    : (
                        this.state.ventana && <this.state.ventana />
                      )
                }

              
            </div>
          </Modal.Body>
        </Modal>
        <div className="policy-dashboard">

          <div className="policy-selector">
            <div className="col-12">
              <Card className="policy-selector__card">
                <CardHeader className="policy-selector__header"
                  style={{
                    background: "#003479",
                    color: "#ffffff",
                  }}
                >
                  <h2>
                    <strong>
                      Selecciona una póliza para gestionar su información
                    </strong>
                  </h2>
                </CardHeader>
                <CardBody className="policy-selector__body">
                  <Row>
                    <div className="policy-selector__filters">
                      <br></br>
                      <Col
                        style={{
                          color: "#000000",
                        }}
                        xs="12"
                        md="3"
                      >
                        <label className="policy-selector__label">Tipo de póliza</label>
                        <Select
                          id="rer"
                          name="rer"
                          placeholder="Seleccionar"
                          options={itip}
                          value={selectedOptionit}
                          onChange={this.handleChangeTi}
                          getOptionValue={(option) => this.getTipoPolizaValue(option.value)}
                          menuPortalTarget={document.body}
                          styles={selectStyles}
                        />
                      </Col>
                      <Col
                        style={{
                          color: "#000000",
                        }}
                        xs="12"
                        md="3"
                      >
                        <label className="policy-selector__label">Póliza</label>
                        <Select
                          id="pol"
                          name="pol"
                          placeholder="Seleccionar"
                          options={pol_ram}
                          value={selectedOptionRam}
                          onChange={this.handleChangeRam}
                          menuPortalTarget={document.body}
                          styles={selectStyles}
                        />
                      </Col>
                      <br></br>
                      <Col
                        style={{
                          color: "#000000",
                        }}
                        xs="12"
                        md="3"
                      >
                        <label className="policy-selector__label">Ramo</label>
                        <Input
                          type="text"
                          id="ram"
                          name="ram"
                          placeholder="Tipo Poliza"
                          value={this.state.tipPoliza}
                          disabled="disabled"
                        />
                      </Col>

                      <br></br>
                      <Col xs="12" md="3">
                        <label className="policy-selector__label">Titular</label>
                        <Input
                          type="text"
                          id="disabled-input"
                          name="disabled-input"
                          placeholder="Titular"
                          value={this.state.cliente}
                          disabled="disabled"
                        />
                      </Col>
                    </div>
                    <Input type="hidden" id="idepol" name="idepol" />
                    <Input type="hidden" id="simple" name="simple" />
                    <Input type="hidden" id="asegu" name="asegu" />
                    <Input type="hidden" id="idRam" name="asegu" />
                    <Input type="hidden" id="tipRam" name="asegu" />
                    <Input type="hidden" id="valPrin" name="valPrin" />
                    <Input type="hidden" id="certificado" name="certificado" />
                    <Input type="hidden" id="idclienteF" name="idclienteF" />
                    <Input type="hidden" id="idclienteU" name="idclienteU" />
                    <Input
                      type="hidden"
                      id="dato_deducible"
                      name="dato_deducible"
                    />
                    <Input type="hidden" id="dato_cob" name="dato_cob" />
                    <Input
                      type="hidden"
                      id="tipoPol"
                      name="tipoPol"
                      value={this.state.tipPolizaCodigo}
                    />
                    <Input
                      type="hidden"
                      id="numeroPol"
                      name="numeroPol"
                      value={this.state.numeroPoliza}
                    />
                    <Input type="hidden" id="monedaPol" name="monedaPol" />
                    <Input
                      type="hidden"
                      id="polizaCompleta"
                      name="polizaCompleta"
                    />
                  </Row>
                  <Row className="policy-selector__downloads">
                    <Col xs="12" md="6" id="dv_infoPoliza">
                      <h5 className="policy-selector__download" style={{ color: "#FFFFFF" }}>
                        <strong>
                          Descarga información de tus pólizas{" "}
                          <u
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleGenerate()}
                          >
                            AQUI
                          </u>
                        </strong>
                      </h5>
                    </Col>
                    <Col xs="12" md="6" id="dv_facPendiente">
                      <h5 className="policy-selector__download" style={{ color: "#FFFFFF" }}>
                        {" "}
                        <strong>
                          Descarga facturas pendientes de pago{" "}
                          <u
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleGenerate2()}
                          >
                            AQUI
                          </u>
                        </strong>
                      </h5>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </div>
          </div>
          <div className="policy-actions">
            <div className="policy-actions__header">
              <strong>Gestiona tu información</strong>
            </div>
            <div className="col-sm-12 col-md-4" id="infoasegu" name="infoasegu">
              <Card className="policy-action-card" style={{ cursor: "pointer" }}>
                <a
                  className="card-img-wrap"
                  id="asegus"
                  name="asegus"
                  style={{
                    textDecoration: "none",
                    color: "inherit"
                  }}
                >
                  <CardImg src={this.state.imag} />
                </a>
              </Card>
            </div>

            <div className="col-xs-12 col-sm-4" id="poliza" name="poliza">
              <Card className="policy-action-card" style={{ cursor: "pointer" }}>
                <div className="card-img-wrap" onClick={() => this.showModal(1)}>
                  <CardImg src={cardPoliza} />
                </div>
              </Card>
            </div>
            <div className="col-xs-12 col-sm-4" id="asesor" name="asesor">
              <Card className="policy-action-card" style={{ cursor: "pointer" }}>
                <div className="card-img-wrap" onClick={()=> this.showModal(2)}>
                  <CardImg src={cardAsesor} />
                </div>
              </Card>
            </div>
            <div
              className="col-xs-12 col-md-3"
              id="gestiones"
              name="gestiones"
              style={{ display: "none" }}
            >
              <Card className="policy-action-card" style={{ cursor: "pointer" }}>
                <a
                  className="card-img-wrap"
                  href={
                    "https://reclamos.somit.com?data=" +
                    encodeURIComponent(
                      Encriptar(
                        "dpi=" +
                          (sessionStorage.getItem("dpi") || $("#hidedpi").val()) +
                          "&fnac=" +
                          Moment.utc(
                            sessionStorage.getItem("fechaNac") || $("#hidefecnac").val()
                          ).format("YYYY-MM-DD")
                      )
                    )
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <CardImg src={cardGestiones} />
                </a>
              </Card>
            </div>
            <div
              className="col-xs-12 col-md-3"
              id="cuenta"
              name="cuenta"
              style={{ display: "none" }}
            >
              <Card className="policy-action-card" style={{ cursor: "pointer" }}>
                <div className="card-img-wrap" onClick={()=> this.showModal(3)}>
                  <CardImg src={pag} />
                </div>
              </Card>
            </div>

            <div
              className="col-xs-12 col-md-3"
              id="dvRedProveedores"
              name="dvRedProveedores"
              style={{
                display: "none",
                marginTop: "10px",
              }}
            >
              <Card className="policy-action-card" style={{ cursor: "pointer" }}>
                <div className="card-img-wrap" onClick={()=> this.showModal(6)}>
                  <CardImg src={cardProveedores} />
                </div>
              </Card>
            </div>

            <div
              className="col-xs-12 col-md-3"
              id="divCarnetDigital"
              name="divCarnetDigital"
              style={{
                display: "none",
                marginTop: "10px",
              }}
            >
              <Card className="policy-action-card" style={{ cursor: "pointer" }}>
                <div className="card-img-wrap" onClick={()=> this.showModal(7)}>
                  <CardImg src={cardCarnet} />
                </div>
              </Card>
            </div>

            <div
              className="col-xs-12 col-md-3"
              id="divModuloAsistencias"
              name="divModuloAsistencias"
              style={{
                display: "none",
                marginTop: "10px",
              }}
            >
              <Card
                className="policy-action-card"
                style={{
                  height: "213px",
                  width: "242px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div className="card-img-wrap" onClick={() => this.handleClickNumCabina(1)}>
                  <CardImg src="https://miseguro.somit.com/imagenes/Asistencias.png" />
                  {/*<NumeroCabina telefono={this.state.numeroTelefonoAsis}></NumeroCabina>*/}
                </div>
                <CardFooter
                  style={{
                    background: "#575a5d",
                    color: "#ffffff",
                    textAlign: "center",
                  }}
                >
                  <strong>
                    <u>
                      <a
                        style={{ color: "#ffffff", cursor: "pointer" }}
                        onClick={() => this.handleClickNumCabina(1)}
                      >
                        Asistencias
                      </a>
                    </u>
                  </strong>
                </CardFooter>
              </Card>
            </div>

          </div>
        </div>
        <br></br> <br></br>
        <div
          id="btnEmergencia"
          name="btnEmergencia"
          style={{ display: "none" }}
        >
          <img id="miImagenCabina"
            src=""
            style={{
              maxHeight: "100%",
              maxWidth: "100%",
              width: "400px",
              objectFit: "contain",
            }}
          />
          <a
            style={{ background: "#003479", color: "white" }}
            id="phEmergencia"
            name="phEmergencia"
          >
            <spans id="spNumCabina" style={{ display: "block", fontSize: "20px", marginTop: "-30px", color: "#003479", fontWeight: "bold" }}>
            </spans>
          </a>



        </div>
        {/*<div
          id="divModuloAsistencias"
          name="divModuloAsistencias"
          style={{ display: "none" }}
        >
          <NumeroCabina telefono={this.state.numeroTelefonoAsis}></NumeroCabina>
        </div>*/}
      </div>
    );
  }
}

export default Forms;
